export const visit = (vm, at) => {
at({ "fi": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Onko t\xE4m\xE4n videon katselussa ongelmia?", "playButton": "Toista" } } });
};